/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-use-before-define */
import React from 'react'

const ToolTipQuestionIconWmo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
  >
    <g clipPath="url(#clip0_1426_62595)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.94189 0.91C8.42467 0.91 9.84609 1.49906 10.8947 2.54722C11.9428 3.59585 12.5319 5.01722 12.5319 6.5C12.5319 7.98278 11.9428 9.4042 10.8947 10.4528C9.84604 11.5009 8.42467 12.09 6.94189 12.09C5.45911 12.09 4.03769 11.5009 2.98911 10.4528C1.94099 9.40415 1.35189 7.98278 1.35189 6.5C1.35189 5.01722 1.94095 3.5958 2.98911 2.54722C4.03775 1.49909 5.45911 0.91 6.94189 0.91ZM6.94189 0C5.21783 0 3.56449 0.685035 2.34574 1.90385C1.12699 3.12266 0.441895 4.77607 0.441895 6.5C0.441895 8.22393 1.12693 9.8774 2.34574 11.0962C3.56456 12.3149 5.21796 13 6.94189 13C8.66582 13 10.3193 12.315 11.538 11.0962C12.7568 9.87734 13.4419 8.22393 13.4419 6.5C13.4419 4.77607 12.7569 3.1226 11.538 1.90385C10.3192 0.6851 8.66582 0 6.94189 0Z"
        fill="#3E3E47"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.96758 3.24768C7.22536 3.26439 7.48139 3.29508 7.73453 3.34033C8.51016 3.52052 8.98796 4.08762 9.07248 4.86079C9.14647 5.36433 8.93339 5.86827 8.5112 6.18294C8.3114 6.34096 8.10155 6.4854 7.90053 6.64024C7.60293 6.84023 7.43977 7.17477 7.4721 7.51911C7.49158 7.77015 7.3282 8.00188 7.07604 8.08138C6.80853 8.18981 6.49846 8.11333 6.32163 7.89509C6.26454 7.81086 6.23184 7.71453 6.22666 7.61455C6.18387 6.98673 6.47059 6.37846 6.99282 5.98908C7.21851 5.81356 7.43014 5.623 7.6266 5.41851C7.72027 5.30651 7.77416 5.1702 7.78218 5.02798C7.80189 4.63953 7.53067 4.39942 7.10725 4.38796C6.59575 4.37423 6.17033 4.51548 5.88502 4.95445C5.76435 5.1654 5.51749 5.28382 5.26758 5.25023C4.83254 5.19687 4.63495 4.86903 4.79898 4.47821C4.97177 4.09619 5.28012 3.78442 5.6701 3.59728C6.07133 3.39313 6.51389 3.27371 6.96758 3.24768Z"
        fill="#3E3E47"
      />
      <path
        d="M6.94189 10.208C7.49418 10.208 7.94189 9.76029 7.94189 9.20801C7.94189 8.65572 7.49418 8.20801 6.94189 8.20801C6.38961 8.20801 5.94189 8.65572 5.94189 9.20801C5.94189 9.76029 6.38961 10.208 6.94189 10.208Z"
        fill="#3E3E47"
      />
    </g>
    <defs>
      <clipPath id="clip0_1426_62595">
        <rect
          width="13"
          height="13"
          fill="white"
          transform="translate(0.441895)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default ToolTipQuestionIconWmo
